// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';
import { DataLoader } from "src/modules/01 Global/jsx/data-loader.jsx";
import { MobilePageHeader } from './_mobile-header.jsx';
import { PageTitle } from './_page-title.jsx';
import { HelpfulLinks } from 'src/modules/helpful-links/jsx/component.jsx';

import { Page404 } from './404.jsx';
import { HomePage } from './home.jsx';
import { NoticeboardPage } from './noticeboard.jsx';
import { MyProgramPage } from './my-program.jsx';
import { MyProgramRequestsPage } from './my-program-requests.jsx';
import { MyResearchPage } from './my-research.jsx';
import { FinancesPage } from './finances.jsx';
import { MyDetailsPage } from './my-details.jsx';
import { SupportPage } from './support.jsx';
import { StudentCentre } from './student-centre.jsx';

// Stateless components

export function PortalPage(props) {

    var current_page = props['page'];
    var page_to_load = null;
    var standard_page = true;
    var is_aside_page = false;

    switch(current_page) {
        case '404':
            page_to_load = <Page404 />;
            standard_page = false;
            break;
        case '', 'home':
            page_to_load = <HomePage />;
            standard_page = false;
            break;
        case 'noticeboard':
            page_to_load = <NoticeboardPage />;
            standard_page = false;
            break;
        case 'my-program':
        case 'program-requests':
        case 'my-research':
            page_to_load = <MyProgramPage />;
            break;
        case 'finances':
            page_to_load = <FinancesPage />;
            break;
        case 'my-details':
            page_to_load = <MyDetailsPage />;
            is_aside_page = true;
            break;
        case 'support':
            page_to_load = <SupportPage />;
            break;
        case 'student-centre':
            page_to_load = <StudentCentre />;
            standard_page = false;
            break;
    }

    if(standard_page) {
        // Render pages based on set framework
        return (
            <div className="main__content">
                <PortalContext.Consumer>
                    {renderContent}
                </PortalContext.Consumer>
            </div>
        );
    }

    // Render custom pages as defined
    return (
        <div className="main__content">
            {page_to_load}
        </div>
    );




    //
    // Render
    //

    function renderContent(context) {
        var viewport = context['viewport'];
        var is_mobile = false;

        if(viewport < 3) {
            is_mobile = true;
        }

        return (
            <>
                {is_mobile ? (
                    <>
                        <MobilePageHeader />
                        <div id="main__content" className="page-inner__wrapper">
                            <div className="page-inner__header">
                                <HelpfulLinks />
                            </div>
                            <DataLoader current_page={current_page}>
                                {page_to_load}
                            </DataLoader>
                        </div>
                    </>
                ) : (
                    <div id="main__content" className="page-inner__wrapper">
                        {is_aside_page ? (
                            <div className="page-inner__wrapper--aside">
                                <div className="page-inner__header">
                                    <PageTitle />
                                    <HelpfulLinks />
                                </div>
                                <DataLoader current_page={current_page}>
                                    {page_to_load}
                                </DataLoader>
                            </div>
                        ) : (
                            <>
                                <div className="page-inner__header">
                                    <PageTitle />
                                    <HelpfulLinks />
                                </div>
                                <DataLoader current_page={current_page}>
                                    {page_to_load}
                                </DataLoader>
                            </>
                        )}
                    </div>
                )}
            </>
        );
    }
};


export function PortalTab(props) {

    var current_page = props['page'];
    var tab_to_load = null;

    //
    // Render
    //

    switch(current_page) {
        case 'program-requests':
            tab_to_load = <MyProgramRequestsPage />;
            break;
        case 'my-research':
            tab_to_load = <MyResearchPage />;
            break;
    }

    //return tab_to_load;

    return (
        <DataLoader current_page={current_page}>
            {tab_to_load}
        </DataLoader>
    );
};
